
class ProductType {
  constructor(id, name, price, imgPath1, imgPath2, description) {
    this.id = id;
    this.name = name;
    this.price = price;
    this.imgPath1= imgPath1;
    this.imgPath2= imgPath2;
    this.description= description
  }

}

export default ProductType;